import { NavigationEnd, Router } from '@angular/router';
import { Component } from '@angular/core';
import { UserStorageService } from './Services/user-storage.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'WSCM-Dashboard';
  logged = false;
  hiddenSidebar: boolean = true;
  isChecked:boolean=false;
  currentUrl;
  constructor(public router: Router,private user:UserStorageService){
    //for hidding sidebar and navbar when still not logged in
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const currentUrl = event.url;
        this.currentUrl = currentUrl;
        if (currentUrl.includes('login') || event.urlAfterRedirects.includes('login')) {
          

          this.hiddenSidebar = false;
          this.isChecked=true;
        } else {
          this.hiddenSidebar = true;
          this.isChecked=true;
        }
      }
    });
  }
}


